import { Component } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { UserService } from '../../services/user/user.service';
import { clearAuthStorage, hasRequiredRole, isNullOrUndefined } from '../../services/common-utils/common-utils';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-callback',
  standalone: false,

  templateUrl: './callback.component.html'
})
export class CallbackComponent {
  constructor(private readonly user: UserService,
    private readonly auth: AuthService) { }

  ngOnInit(): void {
    // Check if this is an explicit login or a silent re-auth (token expired)
    const isExplicitLogin = sessionStorage.getItem('explicit_login') === 'true';

    if (!isExplicitLogin) {
      // This is a silent re-auth after token expiration
      // Force full logout to prevent automatic re-authentication
      clearAuthStorage();
      this.auth.logout({
        logoutParams: {
          returnTo: window.location.origin
        }
      });
      return;
    }

    // Clear the flag for next time
    sessionStorage.removeItem('explicit_login');

    this.user.getUser().subscribe({
      next: (user: any) => {
        if (!isNullOrUndefined(user.id) && hasRequiredRole(user.roles)) {
          let postData = {
            appId: environment.appId,
          };
          this.logUser(postData);
        }
      }
    });
  }

  logUser(user: any) {
    this.user.createOrUpdateUser(user).subscribe();
  }
}
